import { h, render, Component } from 'preact';
import preactCompat from 'preact-compat';
import { Router } from 'preact-router';
import PropTypes from 'prop-types';

class AccountInfoProvider extends Component {

  static childContextTypes = {
    accountData: PropTypes.object,
    webToken: PropTypes.string
  };

  readCookie = (name) => {
  	let nameEQ = name + '=';
  	let ca = document.cookie.split(';');
  	for (let i=0;i < ca.length;i++) {
  		let c = ca[i];
  		while (c.charAt(0) === ' ') {
  			c = c.substring(1,c.length);
  		}
  		if (c.indexOf(nameEQ) === 0) {
  			return c.substring(nameEQ.length,c.length);
  		}
  	}
  	return null;
  }

  getChildContext() {
    return {
    	userData: {
    		accountInfo: this.state.accountData,
    		webToken: this.state.webToken
    	}
		};
  }

 	constructor(props) {
		super(props);

		this.state = {
			accountData: null,
			webToken: null
		};
	}

  componentDidMount() {
    const token = this.readCookie('HZAcctWebToken');

    if (token && !this.state.accountData) {
      fetch('https://api.hirezstudios.com/acct/info', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: `{"webToken": "${token}"}`
      })
      .then((response) => response.json()).then((response) => {
        this.setState({ accountData: response, webToken: token });
      });
    }    
  }

  componentDidUpdate() {
    const token = this.readCookie('HZAcctWebToken');

    if (token && !this.state.accountData) {
      fetch('https://api.hirezstudios.com/acct/info', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: `{"webToken": "${token}"}`
      })
      .then((response) => response.json()).then((response) => {
        this.setState({ accountData: response, webToken: token });
      });
    }
  }

	render() {
		return (
			{...this.props}
		);
	}
}

export default AccountInfoProvider;



// WEBPACK FOOTER //
// ./components/AccountInfoProvider.js